import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { PortalList } from '~/features/PortalList';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  return (
    <div className={styles.screen}>
      <ClientSideMenu />
      <div className={styles.content}>
        <PageHeader variant='title' title='ポータル' />
        <div className={styles.body}>
          <Suspense fallback={<Loader />}>
            <PortalList />
          </Suspense>
        </div>
      </div>
    </div>
  );
};
